import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ColDef, ColGroupDef } from '@ag-grid-community/core';
import { LiteratureDocumentListingData } from '@types';

@Component({
  selector: 'ft-literature-document-card-container',
  templateUrl: './literature-document-card-container.component.html',
  styleUrls: ['./literature-document-card-container.component.scss'],
})
export class LiteratureDocumentCardContainerComponent {
  // TODO: add data type
  @Input() rowData: LiteratureDocumentListingData[] | any;
  @Input() columnDefs: (ColDef | ColGroupDef)[];
  @Input() gridContext: any;
  @Input() isCustom = false;
  @Output()
  selectionEmitter = new EventEmitter<LiteratureDocumentListingData>();

  onSelectionChanged(event) {
    this.selectionEmitter.emit(event);
  }
}
